import { useRef } from 'react';

const MAX_POINTS = 8;

export const useDialogsHistory = () => {
  const historyRef = useRef<Record<string, number[]>>({});
  const updateTimesRef = useRef<number[]>([]);

  const updateHistory = (stats: Record<string, number>) => {
    Object.entries(stats).forEach(([page, count]) => {
      if (!historyRef.current[page]) {
        historyRef.current[page] = [];
      }

      historyRef.current[page].push(count);

      if (historyRef.current[page].length > MAX_POINTS) {
        historyRef.current[page].shift();
      }
    });
  };

  const pushStats = (stats: Record<string, number>, updatedAt: number) => {
    updateHistory(stats);

    updateTimesRef.current.push(updatedAt);

    if (updateTimesRef.current.length > MAX_POINTS) {
      updateTimesRef.current.shift();
    }
  };

  return {
    historyRef,
    updateTimesRef,
    pushStats,
  };
};
